import React from 'react';
import { mbnColorPicker } from '../../../../../utils/helpers';
import styles from './Mbn.module.scss';

const Mbn = ({ mbn }) => {
    return (
        <span style={{ backgroundColor: mbnColorPicker(mbn) }} className={styles.mbn}>
            {mbn}
        </span>
    );
};

export default Mbn;
